var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"colAttr":_vm.colAttr,"max-height":"300"}},_vm._l((_vm.colAttr),function(col,index){return _c('el-table-column',{key:index,attrs:{"width":"100","align":"center","prop":col.prop,"label":col.label}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }